import gql from 'graphql-tag';

export default gql`
  query upliftConfig {
    settings {
      uplift {
        apiKey
        apiCode
        pages {
          pageName
          pageValue
        }
      }
    }
    order {
      items {
        id
        ... on FlightOrderItem {
          flight {
            id
            origin {
              code
              displayName
              city
            }
            destination {
              code
              displayName
              city
            }
            departingTime
          }
          price {
            discountType
            total
          }
        }
        ... on BundleOrderItem {
          bundle {
            id
            ancillaries {
              name
              type
              price {
                amount
                __typename
              }
            }
            __typename
          }
        }
        ... on ItineraryAncillaryOrderItem {
          ancillaryType
          isBundledAncillaryIncluded
          price {
            amount
            currency
            __typename
          }
          quantity
          code
          __typename
        }
        ... on TravelerAncillaryOrderItem {
          ancillaryType
          isBundledAncillaryIncluded
          price {
            amount
            currency
            __typename
          }
          quantity
          __typename
        }
        ... on VehicleOrderItem {
          vehiclePrice: price {
            total {
              amount
              currency
            }
          }
          vehicle {
            code
            description
          }
          __typename
        }
        ... on HotelOrderItem {
          hotelPrice: price {
            total
          }
          hotel {
            name
            address
            phone {
              number
              type
              countryPrefix
              country {
                name
                code
                phonePrefixCode
              }
            }
            __typename
          }
          checkin {
            time
          }
          checkout {
            time
          }
          roomType
          roomsCount
          adultCount
          childrenCount
          stayLength
          __typename
        }
        ... on SeatOrderItem {
          isBundledAncillaryIncluded
          column
          row
          price {
            amount
          }
        }
      }
      travelers {
        id
        firstName
        lastName
        dateOfBirth
        ssrs {
          code
          title
          price {
            amount
            currency
          }
        }
      }
      price {
        balanceDue
      }
    }
  }
`;
